import { useEffect, useRef } from "react";
import styles from "../Table.module.scss";

type TablePlaceholder = {
  nCol: number;
  selectable?: boolean;
  textNoData: string;
};
export function TablePlaceholder({
  nCol,
  textNoData,
  selectable,
}: TablePlaceholder) {
  const divRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (divRef.current) {
      divRef.current.style.setProperty(
        "--span-columns",
        String(nCol + (selectable ? 1 : 0))
      );
    }
  }, [nCol, selectable]);

  return (
    <div ref={divRef} className={styles.noData}>
      {textNoData}
    </div>
  );
}
